<template>
  <Manifests
    :manifests="manifests"
    @updateManifest="updateManifest" />
</template>
<script>
import { mapState, mapActions } from 'vuex';
import store from './_store';
import Manifests from './_components/Manifests.vue';

export default {
  name: 'ManifestsModule',
  components: {
    Manifests,
  },
  beforeCreate() {
    this.$store.registerModule('$_manifest', store);
  },
  destroyed() {
    this.$store.unregisterModule('$_manifest');
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState('$_manifest', {
      manifests: state => state.manifests,
    }),
  },
  created() {
    this.fetchManifests();
  },
  methods: {
    ...mapActions('$_manifest', [
      'fetchManifests',
      'updateManifest',
    ]),
  },
};
</script>
